import React, {Component} from 'react';
import Header from '../../Layout/Header'
import {Link} from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'
import Sidebar from './Sidebar'

class GraphicDesign extends Component {
    render() {
        return (
            <div>
                <Header
                    seoTitle="Graphic Design"
                    title={"graphic design"}
                    image={require('./image-5.jpg')}/>

                <div className="entry-content page-blog">

                    <div className="container-fluid">
                        <h2 className="outline text-center">
                            <div className="line"></div>
                            <div className="title">
                                <img
                                    src={require("./moshi-icon.png")}
                                    alt="Icon"
                                    width="48"
                                    style={{
                                    marginTop: -18,
                                    marginBottom: -12,
                                    marginRight: 12
                                }}/>
                                Graphic Design
                            </div>
                        </h2>
                    </div>

                    <div className="container">


                                <div className="row">
                                    <div className="col-lg-12">

                                        <p>Graphic Design refers to your visually branded marketing material.
                                        </p>

                                        <h4>Our in-house Graphic Designers have a combined 30 years' experience in the
                                            field, and prepare professional print-ready or digital files of the highest
                                            quality.</h4>

                                        <p>Our Graphic Design service includes:</p>

                                        <ul class="with-icons">
                                            <li>Signage</li>
                                            <li>Business card design

                                            </li>
                                            <li>Vehicle logos and wraps</li>
                                            <li>Powerpoint deck templates</li>
                                            <li>Flyers and brochures</li>
                                            <li>Posters and pullup banners</li>
                                            <li>Art pieces that work with your branding</li>

                                        </ul>
                                        <p>The designers here at Moshi Moshi love putting pen to paper (or pen to
                                            tablet!) to create engaging, functional, unique pieces for businesses in Bunbury
                                            and the South West.

                                        </p>
                                        <p>A little bit of good design goes a long way. The professional edge our
                                            graphic designers can give a business card may be the difference between it
                                            being pinned on the to-do board or thrown in the rubbish.
                                        </p>

                                        <p>Good graphic design helps people read information more clearly, thereby
                                            retaining the message more effectively than if they saw the same details printed
                                            in black and white on photocopy paper.</p>
                                        <p>At Moshi Moshi, we pride ourselves on creative designs that stay true to your
                                            brand, but stick out from the crowd - there's a reason our clients keep coming
                                            back for their graphic design needs!</p>

                                        <p></p>
                                        <img
                                            src={require('./advocacy.png')}
                                            style={{
                                            padding: 30
                                        }}
                                            height="375"
                                            width="350"
                                            alt="Advocacy WA Tri-fold Brochure"
                                            className="align-centre"
                                            align="centre"/>

                                        <img
                                            src={require('./Solacoat.png')}
                                            style={{
                                            padding: 30
                                        }}
                                            height="375"
                                            width="350"
                                            alt="Solacoat Booklet Example"
                                            className="align-centre"
                                            align="centre"/>

                                        <a href="https://www.moshi.com.au/what-weve-done/enable-wa"><img
                                            src={require('./Enable.png')}
                                            style={{
											padding: 30
										}}
                                            height="375"
                                            width="350"
                                            alt="Enable WA Event Poster"
                                            className="align-centre"
                                            align="centre"/></a>

                                        <img
                                            src={require('./Hollow.png')}
                                            style={{
                                            padding: 30
                                        }}
                                            height="375"
                                            width="350"
                                            alt="The Hollow Beach Bar Posters"
                                            className="align-centre"
                                            align="centre"/>

                                        <img
                                            src={require('./Tally.png')}
                                            style={{
                                            padding: 30
                                        }}
                                            height="375"
                                            width="350"
                                            alt="Tally Health Branded Materials"
                                            className="align-centre"
                                            align="centre"/>

                                        <img
                                            src={require('./BRAG.png')}
                                            style={{
                                            padding: 30
                                        }}
                                            height="375"
                                            width="350"
                                            alt="Bunbury Regional Art Gallery Booklet"
                                            className="align-centre"
                                            align="centre"/>
                                        <br></br>
                                        <hr></hr>
                                        <h2>Related Services</h2>

                                        <a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a>
                                        <a
                                            class="btn"
                                            href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>
                                        <a class="btn" href="https://www.moshi.com.au/whatwedo/brand-and-logo-design">Brand and Logo Design</a>

                                        <a
                                            class="btn"
                                            href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a>
                                        <a class="btn" href="https://www.moshi.com.au/whatwedo/app-development">App Development</a>
                                        <a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-marketing">Social Media Marketing</a>

                                    </div>

                                </div>
                                <hr></hr>
                                <br></br>
                                <h3>Whether you are looking at business cards, flyers, newspaper adverts,
                                    corporate documents or even animated videos, give Moshi Moshi a call to discuss
                                    how we can add that extra ‘wow factor’ to your business’s look.</h3>
							</div>
							
                       

                </div>

            </div>
        );
    }
}

export default GraphicDesign;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/GraphicDesign.js